<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-help</v-icon>
        <v-toolbar-title>{{ title(titleKey1) }} Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="filteredHeaders"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td v-for="column in selectedColumns" :key="column">
                    {{ row.item[column] }}
                  </td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { helplistTitle } from './helplistTitle'

// event listener
// select: logic to be executed when user selected a row
// close: logic to close the helplist screen
export default {
  data() {
    return {
      titleKey1: null,
      titleKey2: null,
      selectedColumns: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    title(fieldKey) {
      return helplistTitle[fieldKey]
    },
    doKeys() {
      this.titleKey1 = this.fieldKey1
      this.titleKey2 = this.fieldKey2 ? this.fieldKey2 : this.fieldKey1
    },
    doHeaders() {
      const headerList = this.fieldList
      const result = []
      headerList.map((data) => {
        if (!data.hidden) {
          this.selectedColumns.push(data.value)
        }
        result.push(data)
      })
      result.push({ text: 'Action', align: 'center', sortable: false, value: null })
      return result
    },
    async doInit() {
      this.doKeys()
      let apiURI = this.apiURI
      if (apiURI) {
        this.loading = true
        try {
          if (this.expand) {
            apiURI = expandURI(apiURI, this.expand)
          }
          this.items = []
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            data.map((result) => {
              const convertList = {}
              this.helplistHeaders.map((header) => {
                const keyfield = header.value
                if (keyfield !== null) {
                  convertList[keyfield] = result[keyfield]
                }
              })
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(data) {
      if (data) {
        const submit = {
          fieldKey1: this.titleKey1,
          fieldKey2: this.titleKey2,
          data
        }
        this.$emit('select', submit)
        this.doClose()
      }
    },
    doClose() {
      this.$emit('close')
    }
  },
  computed: {
    helplistHeaders() {
      return this.doHeaders()
    },
    filteredHeaders() {
      return this.helplistHeaders.filter((header) => !header.hidden)
    }
  },
  watch: {
    fieldKey1(value) {
      this.doInit()
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    apiURI: {
      type: String,
      required: true
    },
    expand: {
      type: Object,
      required: false,
      default: null
    },
    fieldList: {
      type: Array,
      required: true,
      // make sure the value is same as the fieldname defined in dto file
      // add hidden attribute if need to hide the field column
      default: () => [
        { text: 'Fields', value: 'field', hidden: true },
        { text: 'Description', value: 'desc', hidden: true }
      ]
    },
    // the primary key for the whole helplist component
    fieldKey1: {
      type: String,
      required: true
    },
    // add the secondary key if neccessary
    fieldKey2: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<style>
</style>
